"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextModule = void 0;
const base_1 = require("./base");
const util_1 = require("./util");
class TextModule extends base_1.LabeledModule {
    constructor({ variants, caption = { en: "" }, ...rest }) {
        super(rest);
        this._type = "text";
        this._variants = variants;
        this.caption = caption;
    }
    get variants() {
        return this._variants;
    }
    set variants({ mobile, desktop, }) {
        if (!mobile && !desktop) {
            throw new Error("text variant must be specified for at least one of mobile or desktop");
        }
        const newVariants = { ...this.variants };
        if (mobile) {
            newVariants.mobile = mobile;
        }
        if (desktop) {
            newVariants.desktop = desktop;
        }
        this._variants = newVariants;
    }
    // don't validate that a label exists, we need to be able to save drafts without specifying
    // all text fields in the survey
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            return {
                actionRequired: this.actionRequired,
                id: this.id,
                caption: this.caption,
                label: this.label,
                noBorder: this.noBorder,
                variants: this.variants,
                type: this.type,
                style: this.style,
            };
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        const { variants, caption, label, tag, ...base } = this.toBuilderConfig();
        const surveyConfigModule = {
            ...base,
            actionRequired: this.actionRequired,
            content: label[this.languageCode],
        };
        surveyConfigModule.style = {
            ...this.style,
            "@media(max-width: 599px)": {
                ...TextVariants[variants.mobile],
            },
            "@media(min-width: 600px)": {
                ...TextVariants[variants.desktop],
            },
        };
        // if caption, provide two distint text modules to survey config
        if (caption === null || caption === void 0 ? void 0 : caption[this.languageCode]) {
            return [
                surveyConfigModule,
                {
                    ...base,
                    id: (0, util_1.generateUUID)(),
                    content: caption[this.languageCode],
                    style: {
                        ...this.style,
                        "@media(max-width: 599px)": {
                            ...TextVariants.Caption,
                        },
                        "@media(min-width: 600px)": {
                            ...TextVariants.Caption,
                        },
                    },
                },
            ];
        }
        return surveyConfigModule;
    }
    editProps() {
        var _a;
        return {
            id: this.id,
            type: this.type,
            question: (_a = this.label[this.languageCode]) !== null && _a !== void 0 ? _a : "",
            variants: this.variants,
            text: { caption: this.caption.en },
            actionRequired: this.actionRequired,
        };
    }
}
exports.TextModule = TextModule;
const TextVariants = {
    Body1: {
        fontSize: 15,
        lineHeight: "22px",
        fontWeight: 400,
        fontFamily: "Poppins",
    },
    Body2: {
        fontSize: 12,
        lineHeight: "18px",
        fontWeight: 400,
        fontFamily: "Poppins",
    },
    Headline2: {
        fontSize: 26,
        lineHeight: "36px",
        fontWeight: 600,
        fontFamily: "Poppins",
    },
    Headline3: {
        fontSize: 20,
        lineHeight: "28px",
        fontWeight: 500,
        fontFamily: "Poppins",
    },
    Headline4: {
        fontSize: 16,
        lineHeight: "24px",
        fontWeight: 500,
        fontFamily: "Poppins",
    },
    Button: {
        fontSize: 16,
        lineHeight: "24px",
        fontWeight: 600,
        fontFamily: "Poppins",
    },
    Caption: {
        fontSize: 10,
        lineHeight: "16px",
        fontWeight: 400,
        fontFamily: "Poppins",
    },
    Label: {
        fontSize: 15,
        lineHeight: "20px",
        fontWeight: 500,
        fontFamily: "Poppins",
    },
    Subtitle2: {
        fontSize: 11,
        lineHeight: "16px",
        fontWeight: 600,
        fontFamily: "Poppins",
    },
};
//# sourceMappingURL=Text.js.map